import React, { useState } from "react";

import "./Header.scss";
import AppSearch from "./AppSearch/AppSearch";
import HamburgerIcon from "@material-ui/icons/Menu";
import OpenIcon from "@material-ui/icons/OpenInNew";
// import LaunchIcon from "calcite-ui-icons-react/LaunchIcon";
import {
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Popover,
} from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { HeaderLinks } from "./HeaderConfig";

function Header() {
  const [open, setOpen] = useState(false);
  const [subOpen, setSubOpen] = useState(false);
  //const wrapper = createRef();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const menuClick = (e) => {
    e.stopPropagation(); //else it will close the popover
    setOpen(!open);

    setAnchorEl(e.currentTarget);

    if (!open) {
      setSubOpen(false);
    }
  };

  const subMenuClick = (e) => {
    e.stopPropagation(); //else it will close the popover
    setSubOpen(!subOpen);
  };

  const linkClicked = (e, url) => {
    e.stopPropagation(); //else it will close the popover
    window.open(url);
  };

  const closeMenu = () => {
    setOpen(false);
    setAnchorEl(null);
    setSubOpen(false);
  };

  // this hamburger is expexting a pretty specific format to the links, it will fail if the link structure ever changes
  const linksWOchildren = HeaderLinks.filter((h) => !h.children || !h.children.length);
  const linkWchildren = HeaderLinks.find((h) => h.children && h.children.length);

  return (
    <div className="appHeader">
      <div className="navMenu">
        <button
          aria-describedby={"hamburger"}
          className="hamburger"
          type="button"
          onClick={menuClick}
        >
          <IconButton color="primary" aria-label="open menu" component="span">
            <HamburgerIcon />
          </IconButton>
        </button>
        <Popover
          id={"hamburger"}
          open={open}
          anchorEl={anchorEl}
          onClose={closeMenu}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            className="navList"
          >
            {linksWOchildren.map((lnk) => (
              <ListItem
                button
                key={lnk.label}
                className="linkItem"
                onClick={(e) => linkClicked(e, lnk.url)}
              >
                <ListItemText primary={lnk.label} />
                <ListItemSecondaryAction>
                  <OpenIcon />
                </ListItemSecondaryAction>
              </ListItem>
            ))}

            {linkWchildren && (
              <ListItem button onClick={subMenuClick}>
                <ListItemText primary={linkWchildren.label} />
                {subOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            )}
            {linkWchildren && (
              <Collapse in={subOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {linkWchildren.children.map((child) => (
                    <ListItem
                      key={child.label}
                      button
                      className="linkItem nested"
                      onClick={(e) => linkClicked(e, child.url)}
                    >
                      <ListItemText primary={child.label} />
                      <ListItemSecondaryAction>
                        <OpenIcon />
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            )}
          </List>
        </Popover>
      </div>
      <div className="titleArea">
        <h1 className="appTitle">Organisation of Eastern Caribbean States</h1>
        <div className="appSubTitle">OECS</div>
      </div>
      <div className="searchArea">
        <AppSearch />
      </div>
    </div>
  );
}

export default Header;
